import React from "react";
import { useNavigate } from "react-router-dom";
import CustomViewButton from "../../../CustomComponent/custom_view_button";
import { FaCircleXmark } from "react-icons/fa6";
import { extractDate } from "../../../Components/Functions/date.fun";
import Stars from "react-stars";
const tableHead = [
  "Sr.",
  "Webinar Name",
  "Feedback Date",
  "Feedback Rating",
  "Actions",
];

const ViewWebinarFeedbackTable = ({ data = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();

  const goToView = (id) => {
    navigate(`/webinar/view-webinar-feedbacks/${id}`);
  };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td>{item?.webinar?.webinarName || "N/A"}</td>
                <td>{extractDate(item?.createdAt) || "N/A"}</td>
                <td>
                  {item?.feedbackRating ? (
                    <Stars
                      count={5}
                      size={15}
                      value={item?.feedbackRating}
                      edit={false}
                    />
                  ) : (
                    <FaCircleXmark fontSize={"20px"} color="#D80001" />
                  )}
                </td>
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item?.id)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ViewWebinarFeedbackTable;
